import { capitalRepo } from '../repo';

export const capitalService = {
    async getAll(params = {}) {
        try {
            const response = await capitalRepo.getAll(params);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getById(capitalId) {
        if (!capitalId) {
            throw new Error('Capital ID is required');
        }
        try {
            const response = await capitalRepo.getById(capitalId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getByShop(shopId) {
        if (!shopId) {
            throw new Error('Shop ID is required');
        }
        try {
            const response = await capitalRepo.getByShop(shopId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getAllByShop(shopId, params = {}) {
    if (!shopId) {
        throw new Error('Shop ID is required');
    }
    try {
        const response = await capitalRepo.getAllByShop(shopId, params);
        return response;
    } catch (error) {
        throw this.handleError(error);
    }
},

    async getTotalByShop(shopId) {
        if (!shopId) {
            throw new Error('Shop ID is required');
        }
        try {
            const response = await capitalRepo.getTotalByShop(shopId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getByDateRange(params = {}) {
        if (!params.start_date || !params.end_date) {
            throw new Error('Start date and end date are required');
        }
        try {
            const response = await capitalRepo.getByDateRange(params);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async create(data) {
        if (!data.amount || data.amount <= 0) {
            throw new Error('Valid amount is required');
        }
        if (!data.shopId) {
            throw new Error('Shop ID is required');
        }

        try {
            const response = await capitalRepo.create(data);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async update(capitalId, data) {
        if (!capitalId) {
            throw new Error('Capital ID is required');
        }

        try {
            const response = await capitalRepo.update(capitalId, data);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async toggleStatus(capitalId) {
        if (!capitalId) {
            throw new Error('Capital ID is required');
        }

        try {
            const response = await capitalRepo.toggleStatus(capitalId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async delete(capitalId) {
        if (!capitalId) {
            throw new Error('Capital ID is required');
        }

        try {
            const response = await capitalRepo.delete(capitalId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getStats() {
        try {
            const response = await capitalRepo.getAll({ per_page: 1000 });
            const capitals = response.data?.data || [];
            return {
                total: capitals.length,
                total_amount: capitals.reduce((sum, c) => sum + parseFloat(c.amount), 0),
                active: capitals.filter(c => c.status === 'active').length,
                inactive: capitals.filter(c => c.status === 'inactive').length,
            };
        } catch (error) {
            throw this.handleError(error);
        }
    },

    handleError(error) {
        console.error('CapitalService Error:', error);
        return error.response?.data || error;
    },
};